<div class="card-item-snake-top-arrow"></div>
<div class="card-item-snake-top-info-box">
  @if (card().completed || card().started) {
    <div class="started-box"></div>
  } @else {
    <div class="not-started-box"></div>
  }
</div>

<ptl-v3-content-card [item]="cardItem()" [action]="action()" (cardClicked)="onCardOpen()" (actionClicked)="onCardOpen()">
</ptl-v3-content-card>
